<template>
  <el-form class="serach-form" :inline="true" :model="filters" size="small" ref="searchForm">
    <el-form-item class="select_btn" prop="onlineStatus">
      <el-select
        clearable
        class="select_btn_style"
        v-model="filters.onlineStatus"
        placeholder="在线状态"
      >
        <el-option
          v-for="(item, i) in onlineStatusList"
          :key="i"
          :label="item.paramValue"
          :value="item.paramKey"
        ></el-option>
      </el-select>
    </el-form-item>
    
    <el-form-item class="m-l-14" prop="regionTitle">
      <el-input
        clearable
        prefix-icon="el-icon-search"
        size="small"
        v-model.trim="filters.regionTitle"
        placeholder="专区名称"
      ></el-input>
    </el-form-item>
    <el-form-item>
      <butn btntype="primary" title="查询" @click="search"></butn>
      <butn title="重置" @click="reset" class="czButn"></butn>
    </el-form-item>
  </el-form>
</template>

<script>
import butn from "@/components/button/index";
import { getDataMap } from "@/api/sysParam";

export default {
  name: 'PartSearch',

  components: { butn },

  data() {
    return {
      filters: {
        regionTitle: '',
        onlineStatus: ''
      },

      onlineStatusList: ''
    };
  },

  created() {
    this.initTypeList().forEach(item => this.getDictionary({...item}, item.field))
  },

  methods: {
    initTypeList () {
      return [
        {
          name: '职务类别',
          type: 'ONLINE_STATUS',
          field: 'onlineStatusList',
          all: true
        }
      ]
    },

    // 获取数据字典
    getDictionary (params, field) {
      params = typeof params === 'object' ?  (params !== null ? params : {}) : {type: params}
      const TYPE = params.type
      getDataMap(TYPE).then(res => {
        let data = []
        if (params.all) {
          data.push({
            paramKey: '-1',
            paramValue: '全部'
          })
        }
        if (res && res.data && res.data.length) {
          data = data.concat(res.data)
        }
        this[field] = data
      })
    },

    reset () {
      this.onReset()
      this.onSearch(true)
    },

    onReset () {
      this.$refs['searchForm'].resetFields()
    },

    search () {
      this.onSearch(false)
    },

    onSearch (canDraggable) {
      const data = {
        ...this.filters
      }
      if (data.onlineStatus == '-1') {
        delete data.onlineStatus
      }
      this.$emit("search", { ...data, canDraggable })
    },
  },
};
</script>

<style lang="scss" scoped>
$color: #d7dbe0;
$border-radius: 2px;
.serach-form {
  text-align: right;
  & /deep/ .none-margin-right {
    margin-right: 0;
  }
}
</style>
